module.exports = __webpack_public_path__ + "static/media/errorPage.54f70cbb.jpg";